document.addEventListener('DOMContentLoaded', function () {
  const _shippingCbLog =
    typeof window.createLogger === 'function'
      ? window.createLogger('ShippingCalculatorCallback')
      : { log: () => {}, warn: () => {}, error: () => {} };

  const { destination, shippingCountries, euCountries } = window.CartItemsData;
  const reverseCountryNameMap = reverseShippingCountriesJson(shippingCountries);
  var selectedCountryCode = destination;
  const shippingCalculator = document.querySelector('shipping-calculator');
  const ukTotalsCartSummary = document.getElementById('uk-totals-cart-summary');
  const euTotalsCartSummary = document.getElementById('eu-totals-cart-summary');
  const vatExclTotalsCartSummary = document.getElementById('vat-excl-totals-cart-summary');
  const usaTotalsCartSummary = document.getElementById('usa-totals-cart-summary');
  const shippingCalculatorContainer = document.getElementById('shipping-calculator-container');

  if (!shippingCalculator) return;

  // =====================================================
  // Update totals cart summary view as per country
  // =====================================================
  function updateTotalsCartSummary(selectedCountryCode) {
    if (isEuCountry(selectedCountryCode)) {
      euTotalsCartSummary.style.display = 'block';
      ukTotalsCartSummary.style.display = 'none';
      if (vatExclTotalsCartSummary) vatExclTotalsCartSummary.style.display = 'none';
      shippingCalculatorContainer.style.display = 'none';
    } else if (isUsaCountry(selectedCountryCode)) {
      if (usaTotalsCartSummary) usaTotalsCartSummary.style.display = 'block';
      euTotalsCartSummary.style.display = 'none';
      ukTotalsCartSummary.style.display = 'none';
      if (vatExclTotalsCartSummary) vatExclTotalsCartSummary.style.display = 'none';
      shippingCalculatorContainer.style.display = 'none';
    } else if (isVatExclCountry(selectedCountryCode)) {
      if (vatExclTotalsCartSummary) vatExclTotalsCartSummary.style.display = 'block';
      euTotalsCartSummary.style.display = 'none';
      ukTotalsCartSummary.style.display = 'none';
      if (usaTotalsCartSummary) usaTotalsCartSummary.style.display = 'none';
      shippingCalculatorContainer.style.display = 'none';
    } else {
      ukTotalsCartSummary.style.display = 'block';
      euTotalsCartSummary.style.display = 'none';
      if (vatExclTotalsCartSummary) vatExclTotalsCartSummary.style.display = 'none';
      if (usaTotalsCartSummary) usaTotalsCartSummary.style.display = 'none';
      shippingCalculatorContainer.style.display = 'block';
    }
  }

  /**
   * Check if country is in EU
   */
  function isEuCountry(countryCode) {
    return euCountries && euCountries[countryCode];
  }

  /**
   * Check if country is USA
   */
  function isUsaCountry(countryCode) {
    return countryCode.toUpperCase() === 'US';
  }

  /**
   * Check if country is VAT-exclusive AND has a dedicated VAT-excl cart totals card.
   * JE and GG are in the vat_exclusive_countries metafield (they have no UK VAT) but they
   * use UK pricing and the UK cart totals card — they must be excluded here.
   * Adding a new Gulf/Middle-East market only requires a metafield update — no code change.
   */
  function isVatExclCountry(countryCode) {
    const code = countryCode.toUpperCase();
    // JE/GG use UK cart card. US uses its own USA cart card with state selector.
    // All three are in vat_exclusive_countries (single product price, no incl-VAT display)
    // but must not be routed to the shared VAT-excl totals card.
    if (code === 'JE' || code === 'GG' || code === 'US') return false;
    return window.CartItemsDataVatExcl?.vatExclusiveCountries?.[code] != null;
  }

  // =====================================================
  // ✅ Listen for the custom event fired from shipping-calculator.js
  // =====================================================
  shippingCalculator.addEventListener('shipping-selected', function (event) {
    const rate = event.detail;

    if (isEuCountry(selectedCountryCode)) {
      dispatchEUShippingRateSelectionEvent({
        shipping: rate,
        country: shippingCountries[selectedCountryCode],
        code: selectedCountryCode
      });
    } else if (isUsaCountry(selectedCountryCode)) {
      dispatchUSAShippingRateSelectionEvent({
        shipping: rate,
        country: shippingCountries[selectedCountryCode],
        code: selectedCountryCode
      });
    } else if (isVatExclCountry(selectedCountryCode)) {
      dispatchVatExclShippingRateSelectionEvent({
        shipping: rate,
        country: shippingCountries[selectedCountryCode],
        code: selectedCountryCode
      });
    } else {
      dispatchUKShippingRateSelectionEvent({
        shipping: rate,
        country: shippingCountries[selectedCountryCode],
        code: selectedCountryCode
      });
    }
  });

  // =====================================================
  // Listen Country selection Event
  // =====================================================
  shippingCalculator.addEventListener('shipping-country-selected', function (event) {
    const selectedCountryName = event.detail;
    const country = reverseCountryNameMap[selectedCountryName];
    selectedCountryCode = country.code;
    checkMarketRedirection(selectedCountryCode);
  });

  function isSharedEuCountry(countryCode) {
    const DEDICATED_MARKETS = ['DE', 'FR'];
    return isEuCountry(countryCode) && !DEDICATED_MARKETS.includes(countryCode.toUpperCase());
  }

  function isOnEuMarketPath() {
    return /^\/(en-eu)(\/|$)/i.test(window.location.pathname);
  }

  function isOnJeMarketPath() {
    return /^\/(en-je)(\/|$)/i.test(window.location.pathname);
  }

  function isOnGgMarketPath() {
    return /^\/(en-gg)(\/|$)/i.test(window.location.pathname);
  }

  function isOnUsaMarketPath() {
    return /^\/(en-us)(\/|$)/i.test(window.location.pathname);
  }

  function checkMarketRedirection(selectedCountryCode) {
    const code = selectedCountryCode.toUpperCase();

    // Jersey dedicated market — update totals in-place when already on /en-je.
    if (code === 'JE') {
      if (isOnJeMarketPath()) {
        _shippingCbLog.log('Already on /en-je, updating totals in-place');
        updateTotalsCartSummary(selectedCountryCode);
        return;
      }
      switchShopifyMarket(selectedCountryCode);
      return;
    }

    // Guernsey dedicated market — update totals in-place when already on /en-gg.
    if (code === 'GG') {
      if (isOnGgMarketPath()) {
        _shippingCbLog.log('Already on /en-gg, updating totals in-place');
        updateTotalsCartSummary(selectedCountryCode);
        return;
      }
      switchShopifyMarket(selectedCountryCode);
      return;
    }

    // USA dedicated market — state tax handled client-side, no page reload needed.
    if (isUsaCountry(selectedCountryCode)) {
      if (isOnUsaMarketPath()) {
        _shippingCbLog.log('Already on /en-us, updating USA totals in-place');
        dispatchUSACountrySelectionEvent(
          shippingCountries[selectedCountryCode] ? shippingCountries[selectedCountryCode].country : selectedCountryCode,
          selectedCountryCode
        );
        updateTotalsCartSummary(selectedCountryCode);
        return;
      }
      switchShopifyMarket(selectedCountryCode);
      return;
    }

    // Any VAT-exclusive dedicated market (AE, SA, QA, …)
    // The market path is derived from the ISO code: AE → /en-ae, SA → /en-sa, QA → /en-qa.
    if (isVatExclCountry(selectedCountryCode)) {
      const marketPath = new RegExp(`^/(en-${code.toLowerCase()})(/|$)`, 'i');
      if (marketPath.test(window.location.pathname)) {
        _shippingCbLog.log(`Already on /en-${code.toLowerCase()}, updating totals in-place for:`, selectedCountryCode);
        dispatchVatExclCountrySelectionEvent(
          shippingCountries[selectedCountryCode] ? shippingCountries[selectedCountryCode].country : selectedCountryCode,
          selectedCountryCode
        );
        updateTotalsCartSummary(selectedCountryCode);
        return;
      }
      // Not on the correct market path yet — switch market (full page reload).
      switchShopifyMarket(selectedCountryCode);
      return;
    }

    if (isSharedEuCountry(selectedCountryCode)) {
      try {
        localStorage.setItem('n4y_eu_country', selectedCountryCode);
      } catch (_) {}

      // Already on /en-eu — update totals in-place; submitting the form here
      // would cause an infinite reload loop because the shipping calculator
      // fires shipping-country-selected again on each page load.
      if (isOnEuMarketPath()) {
        _shippingCbLog.log('Already on /en-eu, updating totals in-place for:', selectedCountryCode);
        dispatchEUCountrySelectionEvent(
          shippingCountries[selectedCountryCode] ? shippingCountries[selectedCountryCode].country : selectedCountryCode,
          selectedCountryCode
        );
        updateTotalsCartSummary(selectedCountryCode);
        return;
      }

      // Not yet on /en-eu — submit the localization form so Shopify updates the
      // session country server-side and redirects to /en-eu.
      _shippingCbLog.log('Shared EU country selected, submitting localization form:', selectedCountryCode);
      const localizationFormEl = document.querySelector('localization-form');
      const form = localizationFormEl && localizationFormEl.querySelector('form');
      const countryInput = localizationFormEl && localizationFormEl.querySelector('input[name="country_code"]');

      if (form && countryInput) {
        countryInput.value = selectedCountryCode;
        const localeInput = localizationFormEl.querySelector('input[name="locale_code"]');
        if (localeInput) localeInput.value = 'en';

        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.appendChild(returnInput);
        }
        returnInput.value = window.location.pathname + window.location.search;

        try {
          showNavigationLoader();
        } catch (_) {}
        form.submit();
        return;
      }

      // Fallback if no localization form is found on the page.
      _shippingCbLog.warn('No localization form found, falling back to event dispatch.');
      dispatchEUCountrySelectionEvent(
        shippingCountries[selectedCountryCode] ? shippingCountries[selectedCountryCode].country : selectedCountryCode,
        selectedCountryCode
      );
      updateTotalsCartSummary(selectedCountryCode);
      return;
    }

    // DE, FR, GB (dedicated markets): switch market URL → full page reload.
    try {
      const customerCountryCode = getCustomerCountryCode();
      if (selectedCountryCode !== customerCountryCode) {
        switchShopifyMarket(selectedCountryCode);
      } else {
        _shippingCbLog.log('No market switch needed.');
      }
    } catch (err) {
      _shippingCbLog.warn('Market switch failed:', err);
    }
  }

  function switchShopifyMarket(countryCode) {
    _shippingCbLog.log('Initiating market switch to country code:', countryCode);
    const currentUrl = window.location.href.split('?')[0];
    const newUrl = `${currentUrl}?country=${countryCode.toUpperCase()}`;
    try {
      showNavigationLoader();
    } catch (e) {
      _shippingCbLog.warn('Failed to show navigation loader:', e);
    }
    window.marketUtils.switchMarketURL(countryCode);
    _shippingCbLog.log('Market switch form submitted for country code:', countryCode, 'New URL:', newUrl);
  }

  /**
   * Show a full-page spinner overlay before navigation.
   */
  function showNavigationLoader() {
    try {
      if (window.externalApiClient && typeof window.externalApiClient._showLoader === 'function') {
        window.externalApiClient._showLoader();
        return;
      }
      if (document.getElementById('market-switch-loader')) return;
      if (!document.getElementById('market-switch-loader-style')) {
        const style = document.createElement('style');
        style.id = 'market-switch-loader-style';
        style.textContent = `
          @keyframes nfy-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          .nfy-spinner { width: 40px; height: 40px; border: 4px solid rgba(0,0,0,0.08); border-top-color: #111827; border-radius: 50%; animation: nfy-spin 1s linear infinite; }
        `;
        document.head.appendChild(style);
      }
      const container = document.createElement('div');
      container.id = 'market-switch-loader';
      container.style.position = 'fixed';
      container.style.left = '0';
      container.style.top = '0';
      container.style.width = '100%';
      container.style.height = '100%';
      container.style.display = 'flex';
      container.style.alignItems = 'center';
      container.style.justifyContent = 'center';
      container.style.background = 'rgba(255,255,255,0.6)';
      container.style.zIndex = '99999';
      const spinner = document.createElement('div');
      spinner.className = 'nfy-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      container.appendChild(spinner);
      document.body.appendChild(container);
    } catch (err) {
      _shippingCbLog.warn('showNavigationLoader failed:', err);
    }
  }

  // =====================================================
  // Dispatch USA Country selection Event
  // =====================================================
  function dispatchUSACountrySelectionEvent(selectedCountryName, selectedCountryCode) {
    window.dispatchCustomEvent('US-shipping-country-selected', {
      country: selectedCountryName,
      code: selectedCountryCode
    });
  }
  // =====================================================
  // Dispatch USA Shipping Rate selection Event
  // =====================================================
  function dispatchUSAShippingRateSelectionEvent(shippingRates) {
    window.dispatchCustomEvent('US-shipping-rate-selected', shippingRates);
  }
  // =====================================================
  // Dispatch VAT-exclusive Country selection Event
  // Fires  ${countryCode}-shipping-country-selected  (e.g. AE-shipping-country-selected)
  // =====================================================
  function dispatchVatExclCountrySelectionEvent(selectedCountryName, selectedCountryCode) {
    window.dispatchCustomEvent(`${selectedCountryCode.toUpperCase()}-shipping-country-selected`, {
      country: selectedCountryName,
      code: selectedCountryCode
    });
  }
  // =====================================================
  // Dispatch VAT-exclusive Shipping Rate selection Event
  // Fires  ${countryCode}-shipping-rate-selected  (e.g. AE-shipping-rate-selected)
  // =====================================================
  function dispatchVatExclShippingRateSelectionEvent(shippingRates) {
    window.dispatchCustomEvent(`${shippingRates.code.toUpperCase()}-shipping-rate-selected`, shippingRates);
  }
  // =====================================================
  // Dispatch UK Country selection Event
  // =====================================================
  function dispatchUKCountrySelectionEvent(selectedCountryName, selectedCountryCode) {
    window.dispatchCustomEvent('UK-shipping-country-selected', {
      country: selectedCountryName,
      code: selectedCountryCode
    });
  }
  // =====================================================
  // Dispatch EU Country selection Event
  // =====================================================
  function dispatchEUCountrySelectionEvent(selectedCountryName, selectedCountryCode) {
    window.dispatchCustomEvent('EU-shipping-country-selected', {
      country: selectedCountryName,
      code: selectedCountryCode
    });
  }
  // =====================================================
  // Dispatch EU Shipping Rate selection Event
  // =====================================================
  function dispatchEUShippingRateSelectionEvent(shippingRates) {
    window.dispatchCustomEvent('EU-shipping-rate-selected', shippingRates);
  }
  // =====================================================
  // Dispatch UK Shipping Rate selection Event
  // =====================================================
  function dispatchUKShippingRateSelectionEvent(shippingRates) {
    window.dispatchCustomEvent('UK-shipping-rate-selected', shippingRates);
  }

  function init() {
    updateTotalsCartSummary(destination);
  }

  init();
});
